"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextCell = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const text_cell_styles_1 = require("./text-cell.styles");
const cell_text_content_component_1 = require("../partials/cell-text-content.component");
const TextCell = ({ children, className, align = 'left', textSize = 'medium', tooltipTitle, multiline, multilineOptions, expanded, }) => (react_1.default.createElement(text_cell_styles_1.StyledTextCell, { size: "small", className: (0, classnames_1.default)({ 'cell-text--small': textSize === 'small' }, className), align: align }, react_1.default.createElement(cell_text_content_component_1.CellTextContent, { expanded: expanded, tooltipTitle: tooltipTitle, multiline: multiline, multilineOptions: multilineOptions }, children)));
exports.TextCell = TextCell;
exports.default = exports.TextCell;
